import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container';
import GoogleMapSearch from '../../../../../common/components/google-map-search';
export const AddLeadComponent = ({ weights,distances,handleInnerFormChange, selectedLead, setPickupLocation, pickupLocations, setDropLocation, dropLocations }: any) => (

    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Name'

                            )
                        }}
                        type="text"
                        value={selectedLead?.Name}
                    />

                    <InputContainer
                        label="Email"
                        name="Email"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Email'

                            )
                        }}
                        type="text"
                        value={selectedLead?.Email}
                    />

                    <InputContainer
                        label="PhoneNumber"
                        name="PhoneNumber"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'PhoneNumber'
                            )
                        }}
                        type="text"
                        value={selectedLead?.PhoneNumber}
                    />
                     <InputContainer
                                      
                                        label="date"
                                        name="date"
                                        onValueChange={(event: any) => {
                                          handleInnerFormChange(
                                            event.target.value,
                                            'date'
                                          )
                                        }}

                                        type="date"
                                        value={selectedLead?.date}
                                    />
 <div className='col-span-full'>
        <InputContainer 
          label="Description"
          name="Description"
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event.target.value,
              'Description'
            )
          }}
          type="text"
          value={selectedLead?.Description}
      /></div>

                </div>
            }
            expandedPanel="leadInfo"
            headerTitle="Lead Info"
        />
         <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
 <InputContainer
         
              label="Dangerous goods"
              name="dangerous_goods"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'dangerous_goods'
                )
              }}
              type="checkbox"
              value={selectedLead?.dangerous_goods}
          />
           <InputContainer

label="weight Unit"
labelField="SystemKeyword"
list={weights}
onValueChange={(event: any, newValue: any) => {
    handleInnerFormChange(
     event.target.value,
   'weightUnit'

  );
}}
type="select"
value={selectedLead?.weightUnit}
valueField="SystemKeyword"
/>
                <InputContainer
                    label="Weight Value"
                    name="weight"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'weightValue'

                        )
                    }}
                    type="number"
                    value={selectedLead?.weightValue}
                />
 <InputContainer

label="Length Unit"
labelField="SystemKeyword"
list={distances}
onValueChange={(event: any, newValue: any) => {
    handleInnerFormChange(
     event.target.value,
   'lengthUnit'

  );
}}
type="select"
value={selectedLead?.lengthUnit}
valueField="SystemKeyword"
/>
                <InputContainer
                    label="Length Value"
                    name="length"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'lengthValue'
                        )
                    }}
                    type="number"
                    value={selectedLead?.lengthValue}
                />
                <InputContainer

label="Breadth Unit"
labelField="SystemKeyword"
list={distances}
onValueChange={(event: any, newValue: any) => {
    handleInnerFormChange(
     event.target.value,
   'breadthUnit'

  );
}}
type="select"
value={selectedLead?.breadthUnit}
valueField="SystemKeyword"
/>
                
 <InputContainer
                    label="Breadth Value"
                    name="breadth"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'breadthValue'
                        )
                    }}
                    type="number"
                    value={selectedLead?.breadthValue}
                />
                <InputContainer

label="Height Unit"
labelField="SystemKeyword"
list={distances}
onValueChange={(event: any, newValue: any) => {
    handleInnerFormChange(
     event.target.value,
   'heightUnit'

  );
}}
type="select"
value={selectedLead?.heightUnit}
valueField="SystemKeyword"
/>
                 <InputContainer
                    label="height Value"
                    name="heightValue"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'heightValue'
                        )
                    }}
                    type="number"
                    value={selectedLead?.heightValue}
                />
                <InputContainer
                    label=" Price value"
                    name="Price"
                    onValueChange={(event: any) => {
                        handleInnerFormChange(
                            event.target.value,
                            'value'

                        )
                    }}
                    type="number"
                    value={selectedLead?.value}
                />

            </div>
            }
            expandedPanel="dimensionsInfo"
            headerTitle="Dimensions Info"
        />
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-2 lg:grid-cols-3 gap-4'>
                    <div className="col-span-2">
                        <InputLabelContainer
                            label="From"
                        />
                        <GoogleMapSearch
                            setLocation={setPickupLocation}
                            location={pickupLocations}
                            placeholder="From Address" />
                    </div>

                    <div className="col-span-2">
                        <InputLabelContainer
                            label="To"
                        />
                        <GoogleMapSearch
                            setLocation={setDropLocation}
                            location={dropLocations}
                            placeholder="To Address" />
                    </div>





                </div>
            }
            expandedPanel="addressInfo"
            headerTitle="Address Info"
        />
    </>

)
export default AddLeadComponent;
